export default "__VITE_ASSET__DFxTzS7$__"